// extracted by mini-css-extract-plugin
module.exports = {"body":"EmptyList_body__2kED_","emptyImage":"EmptyList_emptyImage__3oz1T"};